import { ConfirmationDialog } from "@/components/modal/ConfirmationDialog";

export function ShiftCodeDeleteDialog({
  open,
  isPending,
  onOpenChange,
  onConfirm,
}: {
  readonly open: boolean;
  readonly isPending: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onConfirm: () => void;
}) {
  return (
    <ConfirmationDialog
      open={open}
      isPending={isPending}
      onClose={() => onOpenChange(false)}
      onConfirm={onConfirm}
      heading="근무코드 삭제"
      confirmText="삭제"
      title="정말로 이 근무코드를 삭제하시겠습니까?"
      pendingText="삭제 중"
    />
  );
}
